import React from "react";
import "./About.css";

const About = () => {
  return (
    <section className="about">
      <div className="about-container">
        <div className="about-content">
          <h2 className="about-title">Our Story</h2>
          <p className="about-text">
            The idea was born from a group of enthusiastic individuals who
            understood the value of time and the need for quick, accessible
            income. We believe that there should be a way for people to leverage
            their skills, hobbies, and interests to earn money without
            committing to long-term gigs or complex side hustles. And so, our
            platform was conceived.
          </p>
        </div>
        <div className="about-image">
          <img src="/api/placeholder/500/400" alt="Professional" />
        </div>
      </div>
    </section>
  );
};

export default About;
